// Client mirror of supabase/functions/_shared/kidAuth.ts.
// Kept in sync manually — no build-time sharing between Deno edge
// functions and the Vite bundle.

export const KID_EMAIL_DOMAIN = "kids.meetmori.app";
const PIN_PASSWORD_PREFIX = "mori_pin_";

export function pinToPassword(pin: string): string {
  return PIN_PASSWORD_PREFIX + pin;
}

export function usernameToEmail(username: string): string {
  return `${username.trim().toLowerCase()}@${KID_EMAIL_DOMAIN}`;
}

const USERNAME_RE = /^[a-z][a-z0-9_]{2,19}$/;

export function isValidUsername(raw: string): boolean {
  return USERNAME_RE.test(raw.trim().toLowerCase());
}

export function isValidPin(raw: string): boolean {
  return /^\d{4}$/.test(raw);
}

export function isWeakPin(pin: string): boolean {
  if (!/^\d{4}$/.test(pin)) return true;
  const [a, b, c, d] = pin.split("").map(Number);
  if (a === b && b === c && c === d) return true;
  if (b - a === 1 && c - b === 1 && d - c === 1) return true;
  if (b - a === -1 && c - b === -1 && d - c === -1) return true;
  if (a === c && b === d && a !== b) return true;
  if (a === b && c === d && a !== c) return true;
  return false;
}

export function isKidEmail(email: string | null | undefined): boolean {
  if (!email) return false;
  return email.toLowerCase().endsWith(`@${KID_EMAIL_DOMAIN}`);
}
